export enum Reactions {
	like = 'like',
	love = 'love',
	clap = 'clap',
}
